<template>
  <FormSection
    :title="$t('APP.RELEASES.ALPHA_RELEASE.TITLE')"
    :description="$t('APP.RELEASES.ALPHA_RELEASE.DESCRIPTION')"
    description-position="top"
    color-description="rgba(0, 0, 0, 0.66)"
    class="app-releases"
  >
    <div v-if="app.alphaEnabled" class="small-12 columns group__container">
      <ElButton
        type="primary"
        native-type="button"
        icon="el-icon-plus"
        class="group__create-button"
        @click="showAddAlphaGroupModal = true"
      >
        {{ $t('NEW_GROUP') }}
      </ElButton>
      <AddAlphaGroupModal
        ref="alphaGroupModal"
        v-model="showAddAlphaGroupModal"
        :package-name="packageName"
        :group-id="groupId"
        :default-group-name="defaultGroupName"
        @update-parent="updateParentData"
      />
      <div class="group__loading-box">
        <div class="group__center-box">
          <Loading v-if="loading" v-show="loading" height="100%" />
          <p v-else-if="!alphaGroup?.length">
            {{ $t('APP.RELEASES.ALPHA_RELEASE.NO_GROUPS') }}
          </p>
          <AlphaTable
            v-else-if="alphaGroup?.length"
            :data="alphaGroup"
            @edit="editGroup"
            @delete="deleteGroup"
          />
        </div>
      </div>
    </div>
    <div class="small-12 columns group__container">
      <h4>{{ $t('APP.RELEASES.BETA_RELEASE.TITLE') }}</h4>
      <p>{{ $t('APP.RELEASES.BETA_RELEASE.DESCRIPTION') }}</p>
      <div v-if="app.betaEnabled" class="beta__info-box">
        <div class="beta__info-row beta__info-header">
          <div class="beta__info-cell">تاریخ فعال‌سازی</div>
          <div class="beta__info-cell">تعداد اعضای فعال</div>
          <div class="beta__info-cell">{{ '' }}</div>
        </div>
        <div class="beta__info-row">
          <div class="beta__info-cell">
            {{ translateDate(betaGroup[0].created, lang) }}
          </div>
          <div class="beta__info-cell">
            {{ betaGroup[0].memberCount }}
          </div>
          <div class="beta__info-cell">{{ '' }}</div>
        </div>
      </div>
    </div>
  </FormSection>
</template>

<script>
import FormSection from '@@/common/layout/FormSection';
import AddAlphaGroupModal from './AddAlphaGroupModal.vue';
import packageName from '@/mixins/packageName';
import { mapActions, mapGetters } from 'vuex';
import {
  ALPHA_GROUP,
  REMOVE_GROUP_RELEASE,
  GROUP_RELEASE,
  BETA_GROUP,
  APP_DETAILS,
} from '@/store/types';
import AlphaTable from './AlphaTable.vue';
import Loading from '@@/common/Loading';
import lang from '@/mixins/lang';
import { translateDate } from '@/utils/date';
export default {
  name: 'Alpha',
  components: {
    FormSection,
    AddAlphaGroupModal,
    AlphaTable,
    Loading,
  },
  mixins: [packageName, lang],
  data() {
    return {
      showAddAlphaGroupModal: false,
      loading: false,
      groupId: null,
      defaultGroupName: '',
    };
  },
  computed: {
    ...mapGetters({
      alphaGroup: ALPHA_GROUP,
      betaGroup: BETA_GROUP,
      app: APP_DETAILS,
    }),
  },
  watch: {
    showAddAlphaGroupModal(newVal, oldVal) {
      if (oldVal && !newVal) {
        this.groupId = null;
        this.defaultGroupName = '';
      }
    },
  },
  created() {
    this.loading = true;
    this.initialData();
  },
  methods: {
    ...mapActions({
      removeGroup: REMOVE_GROUP_RELEASE,
      getReleaseGroup: GROUP_RELEASE,
    }),
    translateDate,
    initialData() {
      if (!this.alphaGroup) {
        this.getReleaseGroup(this.packageName);
      }
      this.loading = false;
    },

    updateParentData({ groupId, defaultGroupName }) {
      // Method that child can call to update parent data
      if (groupId !== undefined) this.groupId = groupId;
      if (defaultGroupName !== undefined)
        this.defaultGroupName = defaultGroupName;
    },
    editGroup(id) {
      this.groupId = id;
      this.defaultGroupName = this.alphaGroup?.find(
        group => group.id === id,
      ).name;
      this.showAddAlphaGroupModal = true;
    },
    async deleteGroup(id) {
      const group = this.alphaGroup?.find(group => group.id === id);
      const groupName = group ? group.name : 'گروه';

      try {
        await this.$confirm(
          `آیا از حذف گروه "${groupName}" اطمینان دارید؟`,
          'تأیید حذف',
          {
            confirmButtonText: 'حذف',
            cancelButtonText: 'انصراف',
            type: 'warning',
            confirmButtonClass: 'el-button--danger',
          },
        );

        await this.removeGroup({
          packageName: this.packageName,
          id,
        });

        this.$message.success(`گروه "${groupName}" با موفقیت حذف شد`);
      } catch (error) {
        if (error === 'cancel') {
          this.$message.info('عملیات حذف لغو شد');
        } else {
          this.$message.error('خطا در حذف گروه');
        }
      }
    },
  },
};
</script>

<style lang="scss">
.group {
  &__container {
    display: flex;
    flex-direction: column;
    gap: 1rem;
    padding-bottom: 2rem;
  }
  &__create-button {
    max-width: max-content;
  }
  &__loading-box {
    display: flex;
    flex: 1;
    flex-direction: column;
    background-color: rgba(255, 255, 255, 1);
    border-radius: $global-radius;
    width: 100%;
    min-height: 5rem;
  }
  &__center-box {
    display: flex;
    flex: 1;
    flex-direction: column;
    justify-content: center;
    align-items: center;
  }
}

.beta {
  &__info-box {
    border-radius: $global-radius;
    background-color: #fff;
    overflow: hidden;
    margin-top: 1rem;
  }

  &__info-row {
    display: grid;
    grid-template-columns: repeat(3, 1fr);

    &:not(:last-child) {
      border-bottom: 1px solid #e8e8e8;
    }
  }

  &__info-header {
    background-color: #fff;
    font-weight: 500;
    color: rgba(0, 0, 0, 0.87);
  }

  &__info-cell {
    padding: 1rem;
    text-align: center;

    &:first-child {
      border-left: none;
    }
  }

  &__stats {
    display: flex;
    justify-content: center;
    align-items: center;
    gap: 0.5rem;
    padding: 1rem;
    background-color: #fff;
  }

  &__stat-badge {
    background-color: #0099ff;
    color: #fff;
    padding: 0.25rem 0.75rem;
    border-radius: 4px;
    font-weight: 500;
    font-size: 0.9rem;
  }
}
</style>
